/* if you modify this file, please remove this line then fix eslint errors. */ /* eslint-disable */
import { combineReducers } from 'redux';

import informationForm from './informationForm';

export const LEARNING_PATH_STATE_KEY = 'learning_path';

export default combineReducers({
  informationForm,
});
